// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { GetOperatorResponse } from '@digitalasset/utility-operator-api-ts-client';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useUtilityOperatorApiClient } from '../../../contexts/UtilityOperatorApiContext';

// TODO: remove operator config once backend is available on all environments
export const useOperatorParty = (): UseQueryResult<string, string> => {
  const utilityOperatorApi = useUtilityOperatorApiClient();

  return useQuery({
    queryKey: ['getOperator'],
    queryFn: async () =>
      utilityOperatorApi.getOperator().then((response: GetOperatorResponse) => response.partyId),
    refetchInterval: false,
  });
};
